import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { finalize } from 'rxjs';

import { Resource } from '../schemas';
import { Messenger, ResourcesService } from '../service';

@Component({
  selector: 'lcm-remove-resource-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, MatProgressBarModule],
  template: `
    <h2 mat-dialog-title>Remove resource</h2>
    <mat-dialog-content> Are you sure you want to remove the resource "{{ data.resource.Title }}"? </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button matButton mat-dialog-close [disabled]="pending()">Cancel</button>
      <button matButton [disabled]="pending()" (click)="remove(data.resource)">Confirm</button>
    </mat-dialog-actions>

    @if (pending()) {
      <mat-progress-bar mode="indeterminate" />
    }
  `,
  styles: ``,
})
export class RemoveResourceDialog {
  resourceService = inject(ResourcesService);
  data = inject(MAT_DIALOG_DATA);
  hostDialog = inject(MatDialogRef);
  messenger = inject(Messenger);

  pending = signal(false);

  remove(resource: Resource) {
    this.pending.set(true);
    this.resourceService
      .delete(resource.Id)
      .pipe(finalize(() => this.pending.set(false)))
      .subscribe({
        next: () => this.hostDialog.close(resource),
        error: this.messenger.handleHttpError,
      });
  }
}
